import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { SearchFacet, SearchFacetValue } from '../../models/http/search-facet';
import { StringStringKeyValuePair } from '../../models/http/StringStringKeyValuePair';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 't4-list-view-facets',
    templateUrl: 'list-view-facets.component.html',
    styleUrls: ['./list-view-facets.component.scss'],
    standalone: false
})

export class ListViewFacetsComponent implements OnInit {

  public selectedFacets: Array<StringStringKeyValuePair> = [];
  public searchFacets: SearchFacet[] | null = null;
  private originalFacetFields: Set<string> = new Set();

  @Output() onSelect: EventEmitter<StringStringKeyValuePair[]> = new EventEmitter<StringStringKeyValuePair[]>();

  @Input()
  set facets(f : SearchFacet[]) {
    this.searchFacets = f;
    
    // Store original facet fields on first load (when no facets are selected yet)
    if (this.selectedFacets.length === 0 && f && f.length > 0) {
      this.originalFacetFields.clear();
      f.forEach(facet => this.originalFacetFields.add(facet.FieldName));
    }
  }

  constructor(private translate: TranslateService) {
  }

  clear() {
    this.selectedFacets = [];
  }
  
  toggleFacet(event, fieldName, value) {

    //remove and existing entry if it already exists
    const index = this.facetIndex(fieldName, value);
    
    if (index !== -1) {
        this.selectedFacets = this.selectedFacets.filter((_, i) => i !== index);
    }

    const checkbox = event.target as HTMLInputElement;
    
    if (checkbox.checked) {
      this.selectedFacets = [...this.selectedFacets, {
        Key: fieldName,
        Value: value
      }];
    }

    this.onSelect.emit([...this.selectedFacets]);
    
  }

  facetIndex(fieldName: string, value:string ): number {
    return this.selectedFacets.findIndex(pair => pair.Key === fieldName && pair.Value === value);
  }

  getSelectedCount(fieldName: string): number {
    return this.selectedFacets.filter(pair => pair.Key === fieldName).length;
  }

  hasSelectedValues(fieldName: string): boolean {
    return this.getSelectedCount(fieldName) > 0;
  }

  getTotalSelectedCount(): number {
    return this.selectedFacets.length;
  }

  hasMultipleSelections(): boolean {
    return this.selectedFacets.length >= 1;
  }

  clearAll(): void {
    this.selectedFacets = [];
    this.onSelect.emit([]);
  }

  getOriginalFacets(): SearchFacet[] {
    if (!this.searchFacets) return [];
    
    return this.searchFacets
      .filter(facet => this.originalFacetFields.has(facet.FieldName))
      .sort((a, b) => a.FieldName.localeCompare(b.FieldName));
  }

  getNewFacets(): SearchFacet[] {
    if (!this.searchFacets) return [];
    
    return this.searchFacets
      .filter(facet => !this.originalFacetFields.has(facet.FieldName))
      .sort((a, b) => a.FieldName.localeCompare(b.FieldName));
  }

  hasNewFacets(): boolean {
    return this.getNewFacets().length > 0;
  }

  ngOnInit() {

  }

getValueTranslation(value: string) {
  var translateKey = 'COMPONENTS.COMMON.SEARCH.FACET.VALUE.' + value.toUpperCase();

  if (this.translationExists(translateKey))
    return translateKey;

  return value;
}

translationExists(key: string): boolean {
    let exists = false;
    const translation = this.translate.instant(key);
    exists = translation !== key; // Check if the translation differs from the key
    return exists;
  }

}
